import { render } from "./HeadingModal.vue?vue&type=template&id=9db8aaca&scoped=true"
import script from "./HeadingModal.vue?vue&type=script&lang=js"
export * from "./HeadingModal.vue?vue&type=script&lang=js"

import "../../../../reports/css/modal.css?vue&type=style&index=0&id=9db8aaca&scoped=true&lang=css"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9db8aaca"]])

export default __exports__